import { scrollToSection, WHATSAPP_URL } from "./Navbar";
import bolloArt from "../assets/bollo-art.png";

const LINKS = [
  { label: "Novità", href: "#novita", testid: "footer-link-novita" },
  { label: "La Storia", href: "#storia", testid: "footer-link-storia" },
  { label: "Assortimento", href: "#prodotti", testid: "footer-link-prodotti" },
  { label: "Torte", href: "#torte", testid: "footer-link-torte" },
  { label: "Contatti", href: "#contatti", testid: "footer-link-contatti" },
];

export const Footer = () => (
  <footer className="bg-[#84232a] text-[#fbf6f1] pt-16 pb-8" data-testid="main-footer">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-10 pb-12 border-b border-[#fbf6f1]/20">
        <div className="flex items-center gap-6">
          <img
            src={bolloArt}
            alt="Bollo Pasticceria San Vigilio"
            className="w-32 h-32 sm:w-36 sm:h-36 object-contain shrink-0"
            data-testid="footer-logo"
          />
          <p className="text-[#fbf6f1]/75 text-sm max-w-xs leading-relaxed">
            Pasticceria artigianale nel centro storico di Trento.
            Qualità, tradizione ed eleganza dal 1999.
          </p>
        </div>
        <nav className="flex flex-wrap gap-x-8 gap-y-3 text-sm" aria-label="Navigazione footer">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              onClick={(e) => scrollToSection(e, l.href)}
              className="text-[#fbf6f1]/85 hover:text-[#fbf6f1] transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-link"
            className="text-[#fbf6f1]/85 hover:text-[#fbf6f1] transition-colors duration-300"
          >
            WhatsApp
          </a>
        </nav>
      </div>
      <div className="flex flex-col sm:flex-row items-center justify-between gap-3 pt-7 text-xs text-[#fbf6f1]/60">
        <span data-testid="footer-copyright">
          © {new Date().getFullYear()} Pasticceria San Vigilio — Via S. Vigilio, 8, Trento · Mar – Dom 8:00 – 19:30 · Lunedì chiuso
        </span>
        <span className="font-script text-lg text-[#fbf6f1]/80">fatto con amore, ogni giorno</span>
      </div>
    </div>
  </footer>
);
